// File: client_serena/src/components/TestInvoiceModal.js
import React from "react";
import {
Box,
List,
ListItem,
ListIcon,
Text,
IconButton,
useDisclosure,
Tooltip
} from "@chakra-ui/react";
import { CheckCircleIcon, InfoOutlineIcon } from "@chakra-ui/icons";

function TestInvoicePopover({ type }) {
const { isOpen, onOpen, onClose } = useDisclosure();
const isGenome = type === "genome";

const items = isGenome
? [
{ label: "DNA Sample Collection", amount: 15000 },
{ label: "Genome Sequencing & Analysis", amount: 120000 },
{ label: "Nutrition Personalization Report", amount: 20000 },
]
: [
{ label: "Blood Test Collection", amount: 10000 },
{ label: "Biomarker Panel Analysis", amount: 55000 },
{ label: "Nutrition Insights Report", amount: 20000 },
];

const total = items.reduce((sum, i) => sum + i.amount, 0);

return (
<Tooltip
label={
<Box p={2} maxW="sm">
<Text fontWeight="bold" mb={2}>
{isGenome ? "🧬 Genome Test Invoice" : "🩸 Biomarker Test Invoice"}
</Text>
<List spacing={2}>
{items.map((item, i) => (
<ListItem key={i} display="flex" justifyContent="space-between">
<Box display="flex" alignItems="center">
<ListIcon as={CheckCircleIcon} color="green.500" boxSize={4} mr={2} />
<Text fontSize="sm">{item.label}</Text>
</Box>
<Text fontSize="sm" color="green.700">₦{item.amount.toLocaleString()}</Text>
</ListItem>
))}
</List>
<Text mt={2} fontWeight="bold">Total: ₦{total.toLocaleString()}</Text>
</Box>
}
placement="top"
hasArrow
>
<IconButton
icon={<InfoOutlineIcon />}
aria-label="View test invoice"
variant="ghost"
colorScheme="gray"
size="sm"
ml={2}
/>
</Tooltip>
);
}

export default TestInvoicePopover;